import React, { useState } from "react";
import {
  Row,
  Col,
  Typography,
  Space,
  Button,
  Image,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import {
  HomeOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  BookOutlined,
  BankOutlined,
  ClockCircleOutlined,
  ArrowRightOutlined,
  HeartOutlined,
  HeartFilled,
} from "@ant-design/icons";
import { theme } from "../../../../utils/theme";
import usePersonnelAdvertService from "../../../../services/usePersonnelAdvertService";
import {
  AiOutlineHome,
  AiOutlineHeart,
  AiOutlineEnvironment,
  AiOutlineDollar,
  AiOutlineBook,
  AiOutlineBank,
  AiOutlineClockCircle,
} from "react-icons/ai";
import { MdOutlineSubtitles } from "react-icons/md";
import { LiaBusinessTimeSolid } from "react-icons/lia";

const { Text } = Typography;
const { TextArea } = Input;

const JobSummary = ({
  imageUrl,
  title,
  experience,
  location,
  education,
  sector,
  position,
  currency,
  isApplicableToApply,
  isFavorite,
  advertId,
  wageAmount,
  wageType,
  coverLetter,
  isApplied,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCoverLetterModalOpen, setIsCoverLetterModalOpen] = useState(false);
  const [form] = Form.useForm();
  const {
    useFavoriteAdvertPersonnel,
    useUnfavoriteAdvertPersonnel,
    useApplyAdvertPersonnel,
  } = usePersonnelAdvertService();

  const { mutateAsync: favoriteAdvert, isPending: isFavoriteAdvertLoading } =
    useFavoriteAdvertPersonnel();
  const {
    mutateAsync: unFavoriteAdvert,
    isPending: isUnfavoriteAdvertLoading,
  } = useUnfavoriteAdvertPersonnel();
  const { mutateAsync: applyAdvert, isPending: isApplyAdvertLoading } =
    useApplyAdvertPersonnel();

  const handleApplyModalOpen = () => {
    if (!isApplicableToApply) return;
    setIsModalOpen(true);
  };

  const handleApplyModalCancel = () => {
    if (isApplyAdvertLoading) return; // Prevent closing during submission
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleApplySubmit = async (values) => {
    try {
      await applyAdvert({
        advertId: advertId,
        coverLetter: values.coverLetter,
      });
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {}
  };

  const handleFavorite = async () => {
    if (isFavoriteAdvertLoading || isUnfavoriteAdvertLoading) return;
    if (isFavorite) {
      await unFavoriteAdvert(advertId);
    } else {
      await favoriteAdvert(advertId);
    }
  };

  const handleShowCoverLetter = () => {
    setIsCoverLetterModalOpen(true);
  };

  const handleCoverLetterModalClose = () => {
    setIsCoverLetterModalOpen(false);
  };

  const details = [
    { icon: <MdOutlineSubtitles size={20} />, label: "Başlık", value: title },
    {
      icon: <LiaBusinessTimeSolid size={20} />,
      label: "Deneyim",
      value: experience,
    },
    {
      icon: <AiOutlineEnvironment size={20} />,
      label: "Konum",
      value: location,
    },
    {
      icon: <AiOutlineDollar size={20} />,
      label: "Maaş",
      value: `${wageType} ${wageAmount} ${currency} `,
    },
    {
      icon: <AiOutlineBook size={20} />,
      label: "Eğitim",
      value: education,
    },
    { icon: <AiOutlineBank size={20} />, label: "Sektör", value: sector },
    {
      icon: <AiOutlineClockCircle size={20} />,
      label: "Pozisyon",
      value: position,
    },
  ];

  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        style={{
          width: "100%",
          display: "flex",
        }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "4px",
              height: "30px",
              backgroundColor: theme.primaryColor,
              marginRight: "12px",
            }}
          />
          <Typography.Title
            level={2}
            style={{
              margin: 0,
              padding: 0,
              fontSize: "24px",
              fontWeight: "bold",
            }}>
            İlan Özeti
          </Typography.Title>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            padding: "16px 0",
          }}>
          <Image
            src={imageUrl}
            style={{
              width: "200px",
              height: "200px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "2px solid #f0f0f0",
            }}
            preview={false}
          />
        </div>
        <div style={styles.container}>
          {details.map((item, index) => (
            <Row
              key={index}
              style={styles.detailRow}
              gutter={[16, 8]}
              align="top">
              <Col xs={4} sm={2}>
                <div style={styles.iconWrapper}>{item.icon}</div>
              </Col>
              <Col xs={20} sm={22}>
                <Row>
                  <Col xs={24} sm={12} style={{ marginBottom: "4px" }}>
                    <Text strong>{item.label}</Text>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Text>{item.value}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
        </div>

        <Button
          onClick={handleApplyModalOpen}
          disabled={!isApplicableToApply}
          style={{
            backgroundColor: isApplicableToApply
              ? theme.primaryColor
              : "#f5f5f5",
            color: isApplicableToApply ? "white" : "rgba(0, 0, 0, 0.25)",
            width: "100%",
            height: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
            cursor: isApplicableToApply ? "pointer" : "not-allowed",
          }}>
          {isApplicableToApply ? (
            <>
              Bu İş Bende
              <ArrowRightOutlined />
            </>
          ) : (
            "Başvuru Daha Önceden Yapıldı"
          )}
        </Button>
        <Button
          onClick={handleFavorite}
          loading={isFavoriteAdvertLoading || isUnfavoriteAdvertLoading}
          style={{
            backgroundColor: "#2c2c2c",
            color: "white",
            width: "100%",
            height: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
            gap: "8px",
          }}>
          {isFavoriteAdvertLoading || isUnfavoriteAdvertLoading
            ? isFavorite
              ? "Favorilerden Çıkarılıyor..."
              : "Favorilere Ekleniyor..."
            : isFavorite
            ? "Favorilerden Çıkar"
            : "Favorilere Ekle"}
          {!isFavoriteAdvertLoading &&
            !isUnfavoriteAdvertLoading &&
            (isFavorite ? (
              <HeartFilled style={{ color: "#ff4d4f" }} />
            ) : (
              <HeartOutlined />
            ))}
        </Button>
      </Space>

      <Modal
        title="Başvuru Ön Yazısı"
        open={isModalOpen}
        onCancel={handleApplyModalCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleApplyModalCancel}
            disabled={isApplyAdvertLoading}>
            İptal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isApplyAdvertLoading}
            onClick={() => form.submit()}>
            Başvur
          </Button>,
        ]}>
        <Form form={form} onFinish={handleApplySubmit} layout="vertical">
          <Form.Item
            name="coverLetter"
            label="Başvuru ön yazısı"
            rules={[
              {
                required: true,
                message: "Lütfen bir ön yazı giriniz",
              },
              {
                min: 50,
                message: "Ön yazı en az 50 karakter olmalıdır",
              },
            ]}>
            <TextArea
              rows={6}
              placeholder="Kendinizi tanıtan bir ön yazı giriniz..."
              maxLength={500}
              showCount
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Ön Yazı"
        open={isCoverLetterModalOpen}
        onCancel={handleCoverLetterModalClose}
        footer={[
          <Button key="close" onClick={handleCoverLetterModalClose}>
            Kapat
          </Button>,
        ]}>
        <Typography.Paragraph style={{ whiteSpace: "pre-line" }}>
          {coverLetter}
        </Typography.Paragraph>
      </Modal>
    </>
  );
};

export default JobSummary;

const styles = {
  container: {
    width: "100%",
    maxWidth: "800px",
  },
  iconWrapper: {
    paddingTop: "4px",
    fontSize: "20px",
  },
  detailRow: {
    marginBottom: "16px",
  },
};
